import React, { useMemo } from "react";
import { GeometryDataColumns } from "./columnNames/NozzleColumns";
import { compactTableProps } from "../../../../../../styles/muiProps";
import { MaterialReactTable } from "material-react-table";
import { useFormContext, useWatch } from "react-hook-form";

const GeometryDataTable = (props) => {
  const { geometryDataFields, handleSaveCell } = props;
  // Read-only material values come from the Design tab material section.
  const { control } = useFormContext();
  const nozzleClean = useWatch({ control, name: "nozzleMaterial" });
  const nozzleLegacy = useWatch({ control, name: "ComboBox12" });
  const flangeClean = useWatch({ control, name: "flangeMaterial" });
  const flangeLegacy = useWatch({ control, name: "ComboBox13" });
  const padClean = useWatch({ control, name: "rfPadMaterial" });
  const padLegacy = useWatch({ control, name: "ComboBox14" });
  const designNozzle = nozzleClean ?? nozzleLegacy ?? "";
  const designFlange = flangeClean ?? flangeLegacy ?? "";
  const designPad = padClean ?? padLegacy ?? "";

  const displayRows = useMemo(
    () =>
      (geometryDataFields ?? []).map((row) => ({
        ...row,
        "Nozzle Material": designNozzle,
        "Flange Material": designFlange,
        "Pad Material": designPad,
      })),
    [geometryDataFields, designNozzle, designFlange, designPad],
  );
  return (
    <MaterialReactTable
      columns={GeometryDataColumns}
      data={displayRows ?? []}
      enableColumnActions={false}
      editDisplayMode="table"
      enableEditing
      enableSorting={false}
      {...compactTableProps}
      muiEditTextFieldProps={({ cell }) => ({
        //onBlur is more efficient, but could use onChange instead
        onBlur: (event) => {
          handleSaveCell(cell, event.target.value, "DataGridView10");
        },
        sx: {
          "& .MuiInputBase-input": {
            padding: "4.5px 4px",
            textAlign: "center",
          },
          borderRight: "1px solid var(--pv-table-border)",
        },
      })}
      muiTableHeadCellProps={({ cell }) => ({
        sx: {
          borderRight: "1px solid var(--pv-table-border)",
          backgroundColor: "var(--pv-table-header-bg)",
          // fontSize: "16px",
          // display: "flex",
          // alignItems: "center",
          // px: 0,
          pt: 2,
          height: "95px",
          "& .Mui-TableHeadCell-Content-Wrapper": {
            whiteSpace: "normal",
            justifyContent: "center",
          },
        },
      })}
    />
  );
};

export default GeometryDataTable;
